module.exports = __webpack_public_path__ + "images/emoji/pushpin.03916a1b43ae63fe0c1e.png";